module.exports = __webpack_public_path__ + "media/images/ellipse-29@2x-b4a7cfe15a506a85a2e44daa0a66d628.png";